import { computed, observable } from 'mobx'
import { GeoJsonPointType } from '../../../graphQL/generated/enums'
import ModelStore from '../../../shared-lib/stores/ModelStore'
import { $RootStore } from '../../../src/stores/RootStore'

export const defaultData = {
  _id: '',
  placeId: '',
  lat: 0,
  lng: 0,
  line1: '',
  line2: '',
  region: '',
  postalCode: '',
  location: {
    type: GeoJsonPointType.Point,
    coordinates: [0, 0],
  },
  professionalId: null,
  staticLocation: null,
}

export type $ExternalAddressModel = ExternalAddressModel

export default class ExternalAddressModel extends ModelStore {
  @observable accessor data: ExternalAddress = { ...defaultData }
  fetchMethodName = 'externalAddress'
  removeMethodName = 'deleteExternalAddress'
  saveMethodName = 'addOrUpdateExternalAddress'

  constructor(data: Partial<ExternalAddress>, rootStore: $RootStore) {
    super(data, rootStore)
    this.data = {
      ...defaultData,
      timezone: rootStore.userStore.timezone,
    }
    this.merge(data)
  }

  saveArgs = (): { data: ExternalAddressInput } => {
    // professionalId and staticLocation are fetched for scoping but aren't part of ExternalAddressInput
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { professionalId, staticLocation, ...data } = this.data
    return { data: data as ExternalAddressInput }
  }

  @computed get addressAsString() {
    const { line1, line2, region, postalCode } = this.data
    return [line1, line2, region, postalCode].filter(Boolean).join(', ')
  }
}
